import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { VertexIndImportConfigPage } from "src/components/views/erp/integrations/vertexInd/VertexIndImportConfigPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/vertexInd/config")({
	staticData: { title: i18n.t("vertex_import_config"), legacyViewKey: "vertexIndImportConfigPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <VertexIndImportConfigPage />;
}
